import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {ToastrService} from "ngx-toastr";
import {Observable, tap} from "rxjs";

@Injectable()
export class HttpToastInterceptor implements HttpInterceptor {
  constructor(private toastrService: ToastrService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            const {method} = request;
            const skipSuccessToast = request.headers.get('X-Skip-Success-Toast');
            if (method !== 'GET' && !skipSuccessToast) {
              this.toastrService.success("Opération réussie");
            }
          }
        },
        (error: any) => {
          if (error instanceof HttpErrorResponse) {
            const errorMessage = error.error?.message || error.message || 'Une erreur est survenue';
            this.toastrService.error(errorMessage);
          }
        }
      )
    );
  }
}
